export default "__VITE_ASSET__Cs9toKf9__"